import React, { useState } from 'react'
import {
  Button,
  DangerButton,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Checkbox,
  useOverlay,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const ConfirmationDialog = ({ title, message, btnLabel, confirmBtnOnClick, isDanger, extra }) => {
  const confirmationOverlay = useOverlay()
  const [t] = useTranslation()
  const [deleteTree] = useState(false)
  const [deleteGroup, setDeleteGroup] = useState(false)

  return (
    <>
      {!isDanger && <Button onClick={confirmationOverlay.handleClick}>{btnLabel}</Button>}
      {isDanger && <DangerButton onClick={confirmationOverlay.handleClick}>{btnLabel}</DangerButton>}
      <DialogOverlay {...confirmationOverlay} title={title}>
        {message}

        {extra && (
          <>
            {/* Also, I haven't found a way to delete a tree */}
            {/* So I am commenting this out */}
            {/* <Checkbox
              label="Also delete the tree"
              name="deleteTree"
              checked={deleteTree}
              onChange={(e) => setDeleteTree(e.target.checked)}
            /> */}
            <Checkbox
              label={t('user.gedcom.deleteGroupAlso', 'Also delete the group')}
              name="deleteGroup"
              checked={deleteGroup}
              onChange={(e) => setDeleteGroup(e.target.checked)}
            />
          </>
        )}

        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button
              emphasis="high"
              onClick={() => {
                confirmBtnOnClick(deleteTree, deleteGroup)
                confirmationOverlay.close()
              }}
            >
              {t('action.confirm', 'Confirm')}
            </Button>
            <Button emphasis="medium" onClick={confirmationOverlay.close}>
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </>
  )
}

export default ConfirmationDialog
